import styled from '@emotion/styled'

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

export const Row = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
`
